import styled from 'styled-components';
import { StyleColor } from '../../../utils/styles-constants';

export const StyledMultiAppAuthenticationPopup = styled('div') `
	position: fixed;
	left: 50%;
	top: 50%;
	z-index: 11;
	background: ${StyleColor.White};
	padding: 60px 40px;
	transform: translate(-50%, -50%);
	width: 90%;
	max-width: 400px;
	box-sizing: border-box;
	align-items: center;
	display: flex;
	flex-direction: column;
`;

export const CloseButton = styled('div') `
	position: absolute;
	right: 10px;
	top: 10px;
	cursor: pointer;

	> svg {
		width: 12px;
		height: 12px;
		padding: 9px;
		fill: ${StyleColor.Grey500};
	}
`;

export const AccessibleAppSelectWrapper = styled('div') `
	width: 100%;
	margin-bottom: 15px;
	position: relative;
`;

export const AccessibleAppSelect = styled('select') `
	width: 100%;
	border: 1px solid ${StyleColor.Grey400};
	height: 40px;
	color: ${StyleColor.Grey500};
	background: ${StyleColor.White};
	padding: 0 15px;
	-webkit-appearance: none;
	-moz-appearance: none;
	outline: none;
`;

export const AccessibleAppSelectIcon = styled('div') `
	position: absolute;
	top: 7.5px;
	right: 7.5px;
	pointer-events: none;

	> svg {
		width: 16px;
		height: 25px;
		fill: ${StyleColor.Grey500};
	}
`;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/MultiAppAuthentication/Popup/styles.ts